{{ score.type }}: {{ score.current }}/{{ score.final }} <span class="lap-weather-divider"></span>
<i class="sports-sb-weather-{{ score.weather }}-i"></i>
